import { ReusablePaymentMethod } from './reusable-payment-method/reusable-payment-method';
import { WalletPaymentMethodInfo } from './wallet-payment-method/wallet-payment-method-info';

export type PaymentMethodInfo = ReusablePaymentMethod | WalletPaymentMethodInfo;
